import { ReactNode, useState } from 'react';
import { IResponseSearchItem, TCategory } from '@legacy/apis/types/searchAPI';
import { Avatar } from '@legacy/components/ui-components/Avatar';
import { Flex } from '@legacy/components/ui-components/Flex';
import { Icon } from '@legacy/components/ui-components/Icon';
import { Link } from '@legacy/components/ui-components/Link';
import DOMPurify from 'dompurify';

import styles from './SearchItem.module.scss';

interface SubMenu {
  pageUrl: string;
  name: string;
  id: number;
  image: string | null;
}

export interface SearchItemData {
  pageIdentifier: string;
  subMenu?: SubMenu[];
}

interface SearchItemProps {
  searchValue: string;
  searchList: IResponseSearchItem[];
  icon: ReactNode;
  category: TCategory;
  categoryLabel: string;
  onItemSelect: () => void;
}

const SearchItem = ({
  searchValue,
  searchList,
  icon,
  category,
  categoryLabel,
  onItemSelect,
}: SearchItemProps) => {
  const [categoryIsOpen, setCategoryIsOpen] = useState(true);

  return (
    <>
      <button
        data-automation-id={`${category}SearchToggleButton`}
        id={`${category}SearchToggleButton`}
        type="button"
        className={styles.SearchCategory}
        aria-controls={`${category}SearchContent`}
        aria-expanded={categoryIsOpen}
        onClick={() => setCategoryIsOpen((prev) => !prev)}
      >
        {icon}
        <span>{categoryLabel}</span>
        <span className={styles.SearchCategoryArrow}>
          <Icon iconName="pointDown" />
        </span>
      </button>

      <div
        id={`${category}SearchContent`}
        className={styles.SearchCategoryResults}
        hidden={!categoryIsOpen}
      >
        {searchList?.map(({ name, id, imageUrl, pageUrl }, index) => (
          <Link
            id={`${category}_${id}`}
            useTextColor
            block
            data-automation-id={`SearchLink${category}${id}`}
            href={pageUrl}
            className={styles.SearchCategoryLink}
            hidden={!categoryIsOpen}
            onClick={onItemSelect}
            key={`${index}_${category}_${id}`}
          >
            <Flex>
              {imageUrl && (
                <Avatar
                  data-automation-id={`SearchItemImg${id}`}
                  src={imageUrl}
                  alt=""
                  size="large"
                />
              )}

              <span
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(name) }}
              ></span>
            </Flex>
          </Link>
        ))}
      </div>
    </>
  );
};

export default SearchItem;
